import { FC, HTMLAttributes } from 'react';
import Stack from '@/shared/components/Stack/Stack';
import Stats from '@/shared/components/Stats/Stats';
import Logo from '@/shared/components/Logo/Logo';
import './Topbar.css';

interface TopbarProps extends HTMLAttributes<HTMLDivElement> {
  showStats?: boolean;
}

const Topbar: FC<TopbarProps> = ({
  children,
  className = '',
  showStats = true,
  ...props
}) => {
  return (
    <Stack as="header" direction="horizontal" align="center" className={`topbar ${className}`} {...props}>
      {children}
      {showStats && <Stats />}
    </Stack>
  );
};

export default Topbar; 
